import { Header } from "../../components/cashierLandingComp/Header";
import { Image } from "antd";
import { useTranslation } from "react-i18next";
import { CheckCircle, Mail, PhoneCall } from "lucide-react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { getUTMs } from "../../Utils/utm";

const CashierThankyou = () => {
  const { i18n, t } = useTranslation();
  const [utms, setUtms] = useState({});

  useEffect(() => {
    const data = getUTMs();

    // remove null values
    // Object.keys(data).forEach((key) => data[key] == null && delete data[key]);
    Object.keys(data).forEach((key) => data[key]);
    setUtms(data);
  }, []);
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>
          myGINNE Cashier POS – Smart Retail System for Egyptian Stores
        </title>
        <meta
          name="description"
          content="Simplify your retail operations with myGINNE, Egypt’s smartest cashier & POS system. Works offline, supports Arabic, and sets up in 10 minutes. Free trial!"
        />
        <meta
          name="keywords"
          content="POS system Egypt, cashier app Egypt, myGINNE POS, retail billing software Egypt, Arabic POS system, store management app, weighing machine POS, barcode billing Egypt, free POS Egypt, grocery store software Egypt"
        />
        <link
          rel="canonical"
          href="https://store.myginne.com/cashier-pos-egypt"
        />

        <meta
          property="og:title"
          content="myGINNE Cashier POS – Smart Retail System for Egyptian Stores"
        />
        <meta
          property="og:description"
          content="Simplify your retail operations with myGINNE, Egypt’s smartest cashier & POS system. Works offline, supports Arabic, and sets up in 10 minutes. Free trial!"
        />
        <meta
          property="og:image"
          content="https://assets.myginne.com/assets/lahloob_prod/OG_Image.jpeg"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://store.myginne.com/" />
      </Helmet>
      <Header utms={utms} />
      <div className="pt-16">
        <div className="flex items-center justify-center bg-gradient-to-br from-green-50 to-white p-6 py-12">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="max-w-md w-full bg-white rounded-2xl shadow-xs p-10 text-center border border-green-100"
          >
            {/* Icon */}
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
              className="mx-auto mb-6 flex items-center justify-center"
            >
              <div className="bg-green-100 p-6 rounded-full">
                <CheckCircle
                  className="w-20 h-20 text-green-600"
                  strokeWidth={1.5}
                />
              </div>
            </motion.div>

            {/* Title & Subtitle */}
            <h1 className="text-4xl font-bold text-gray-900 mb-3 tracking-tight">
              {t("Thank You!")}
            </h1>
            <p className="text-gray-500 text-lg mb-8">
              {t(
                "Your form has been submitted. Our myGINNE team will contact you soon.",
              )}
            </p>
          </motion.div>
        </div>

        <footer className="bg-card border-t border-border py-6">
          <div className="container mx-auto px-4">
            <div className="grid md:[grid-template-columns:1.5fr_1fr_1fr_1fr] gap-8">
              <div className="space-y-1text-sm text-muted-foreground">
                <div className="flex items-center space-x-2 mb-3">
                  <Image
                    src={require("../../assets/Logo/logo.png")}
                    alt="myGINNE logo"
                    width={120}
                    height={40}
                    preview={false}
                  />
                </div>
                <div
                  className={`text-[12px] mb-1 ${
                    i18n.language === "ar" ? "text-right" : "text-left"
                  }`}
                  dir="ltr"
                >
                  {t(
                    "14 Prince Waleed Bin-Thinyan Al-Saud, Sheraton Al Matar, El Nozha, Cairo Governorate 11799",
                  )}
                </div>
              </div>
              <div>
                <h4 className="font-semibold mb-4 text-foreground">
                  {t("Contact Us")}
                </h4>
                <div
                  className={`flex items-center text-[12px] mb-1 ${
                    i18n.language === "ar" ? "justify-end" : "justify-start"
                  }`}
                  dir="ltr"
                >
                  <PhoneCall
                    className={`${
                      i18n.language === "ar" ? "mr-2" : "mr-2"
                    } w-4 h-4 text-primary`}
                  />
                  +20 104 021 1130
                </div>

                <div
                  className={`flex items-center text-[12px] mb-1 ${
                    i18n.language === "ar" ? "justify-end" : "justify-start"
                  }`}
                  dir="ltr"
                >
                  <Mail
                    className={`${
                      i18n.language === "ar" ? "mr-2" : "mr-2"
                    } w-4 h-4 text-primary`}
                  />
                  support@myginne.com
                </div>
              </div>
            </div>

            <div className="border-t border-border pt-6 mt-6 text-center text-muted-foreground">
              <p>
                {t(
                  "© 2025 myGINNE. All rights reserved. Made for Egyptian retailers with ❤️",
                )}
              </p>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default CashierThankyou;
